var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10809",
    "data-name": "Grupo 10809",
    transform: "translate(1518 -391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M21.456,13.741a2.378,2.378,0,0,1,1.526-2.219,9.427,9.427,0,0,0-1.141-2.748,2.41,2.41,0,0,1-.967.207A2.373,2.373,0,0,1,18.7,5.641,9.4,9.4,0,0,0,15.96,4.5a2.376,2.376,0,0,1-4.438,0A9.427,9.427,0,0,0,8.774,5.641,2.373,2.373,0,0,1,6.6,8.981a2.332,2.332,0,0,1-.967-.207A9.635,9.635,0,0,0,4.5,11.527a2.378,2.378,0,0,1,0,4.438,9.427,9.427,0,0,0,1.141,2.748,2.374,2.374,0,0,1,3.133,3.133,9.482,9.482,0,0,0,2.748,1.141,2.372,2.372,0,0,1,4.428,0A9.427,9.427,0,0,0,18.7,21.846a2.376,2.376,0,0,1,3.133-3.133,9.482,9.482,0,0,0,1.141-2.748A2.39,2.39,0,0,1,21.456,13.741Zm-7.672,3.846a3.85,3.85,0,1,1,3.85-3.85A3.849,3.849,0,0,1,13.784,17.586Z",
    transform: "translate(-1517.5 392.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17742",
    "data-name": "Rect\\xE1ngulo 17742",
    width: 30,
    height: 30,
    transform: "translate(-1518 391)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsMenu);
export default __webpack_public_path__ + "static/media/settings-menu.8052ac77b6bed106c17859f71d7ffab2.svg";
export { ForwardRef as ReactComponent };